import { useState, useEffect } from 'react';

type FeatureFlags = 'enableFilePreviews' | 'enableMasterlistCheck';
const useFeatureFlags = () => {
  const [featureFlags, setFeatureFlags] = useState<{
    [key in FeatureFlags]: boolean;
  }>({
    enableFilePreviews: false,
    enableMasterlistCheck: false,
  });

  useEffect(() => {
    const isStaging = import.meta.env.REACT_APP_BUILD === 'staging';
    setFeatureFlags({
      enableFilePreviews: isStaging,
      enableMasterlistCheck: isStaging,
    });
  }, []);

  return featureFlags;
};

export default useFeatureFlags;
